theme.GraphQL = {

  config:  {
    storefront_token: 'a31abf62a4407ddb62b74589033cd8a1',
    request_url: theme.routes.storefrontAPI
  },

  sendRequest: function(request, request_group, output_container) {

    if(this.config[request_group] == null) {
      this.config[request_group] = 1;
    } else {
      this.config[request_group]++;
    }

    let return_response = null;

    let settings = {
      'crossDomain': true,
      'url': this.config.request_url,
      'method': 'POST',
      'headers': {
        'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
        'Content-Type': 'application/graphql',
      },
      'data': request,
      'success': function(response) {
        theme.GraphQL.config[request_group]--;
        return_response = response;
      },
      'error': function(xhr, errDesc) {
        theme.GraphQL.config[request_group]--;
        console.log(errDesc);
      }
    };
    $.ajax(settings)
        .done(function() {
          if(request_group === "also-available") {
            theme.AlsoAvailableIn.buildOutput(return_response);
          }
          if(request_group === "productBundles") {
            theme.ProductBundles.buildOutput(return_response, output_container);
          }
          if(request_group === "grid-swatches") {
            theme.GridSwatches.buildOutput(return_response, output_container);
          }
          if(request_group === "cart-swatches") {
            theme.CartSwatches.buildOutput(return_response, output_container);
          }
          theme.GraphQL.cleanUp(request_group);
        });
  },

  cleanUp: function(request_group) {
    if(theme.GraphQL.config[request_group] < 1) {
      $('body').trigger(request_group+":loaded");
      delete this.config[request_group];
    }
  },

  forceStop: function(request_group) {
    delete this.config[request_group];
  }
};

theme.Helpers2 = {
  addItemToCartFromID: function(id, properties) {
    
    let item_data = [];
    properties = properties || {};

    item_data.push({quantity: 1, id: id, properties: properties});

    $.post('/cart/add.js', {
      items: item_data,
    }, function() {
      $('body').trigger('added.ajaxProduct');
    });
    $('body').trigger('added.ajaxProduct');
  },

  removeItemsFromCart: function(keys) {
    let qty = 0,
        items_data = { updates: {} };

    for(let i=0;i<keys.length;i++) {
      items_data.updates[keys[i]] = qty;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: items_data,
      dataType: 'json',
      success: function() {
        $('body').trigger('added.ajaxProduct');
      }
    });
  },

  removeSingleItemFromCart: function(key) {
    let items_data = { updates: {} },
        qty = 0;
    items_data.updates[key] = qty;

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: items_data,
      dataType: 'json',
      success: function() {
        $('body').trigger('added.ajaxProduct');
      }
    });
  },

  reInitModule: function(module) {
    theme.GraphQL.forceStop(module);
    $('[data-section-type="'+module+'"]').each(function() {
      theme.GridSwatches.init(this);
    });
  },

  retrieveID: function(input) {
    return input.split("/").pop();
  },

  formatMoney: function(cents, format) {
    let money_format = "${{amount}}";

    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    let value = '';
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let formatString = (format || money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      let parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },

  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

};

theme.ProductBundles = (function() {

  let config = {
    search_query:
        `{
          products(first: {{{searchQTY}}}, query: "{{{searchQuery}}}") {
            edges {
              node {
                availableForSale
                title
                images(first: 1) {
                  edges {
                    node {
                      url
                    }
                  }
                }
                variants(first: 100) {
                  edges {
                    node {
                      id
                      title
                      available
                    }
                  }
                }
              }
            }
          }
        }`
  };

  let $container;

  function buildOutput (response,output_container) {

    let $outputContainer = $(output_container),
        product_image = response.data.products.edges[0].node.images.edges[0].node.url || "",
        product_title = response.data.products.edges[0].node.title || "",
        variant_count = response.data.products.edges[0].node.variants.edges.length,
        available = response.data.products.edges[0].node.availableForSale;

    if (!available) {
      $outputContainer.addClass('product-bundle-item--out-of-stock');
    }

    let html = `
        <div class="bundle-product-image">
            <img src="##productImage##"  alt="##productTitle##"/>
        </div>
        <div class="bundle-product-meta">
            <div class="bundle-product-meta__title">
                ##productTitle##
            </div>
            ##productVariants##
        </div>
    `;

    let output = html.replace("##productImage##",product_image);
    output = output.replaceAll("##productTitle##",product_title);

    if (variant_count > 1) {
      // multiple variants
      $outputContainer.addClass('product-bundle-item--has-variants');
      let variant_arr = response.data.products.edges[0].node.variants.edges;
      let variant_html = `
        <div class="bundle-product-meta__variants">
          <select>
          ##variantOptions##
          </select>
        </div>
      `;

      let option_html = `
        <option data-variant-id="##variantId##" ##prop## >##variantTitle##</option>
      `;

      let option_output = '';

      for (let i=0;i<variant_arr.length;i++) {
        let id = retrieveID(variant_arr[i].node.id),
            title = variant_arr[i].node.title,
            available = variant_arr[i].node.available;

        let variant_html = option_html;

        if(!available) {
          title = title + "- Out of stock";
          variant_html = variant_html.replace(" ##prop##", 'disabled');
        } else {
          variant_html = variant_html.replace(" ##prop##", '');
        }

        variant_html = variant_html.replace("##variantId##",id);
        variant_html = variant_html.replace("##variantTitle##",title);

        option_output += variant_html;

      }
      variant_html = variant_html.replace("##variantOptions##",option_output)
      output = output.replace("##productVariants##",variant_html);

    } else if (variant_count === 1) {
      // one variant set for some reason
      let id = retrieveID(response.data.products.edges[0].node.variants.edges[0].node.id);

      let variant_html = `
        <div class='bundle-product-meta__variants bundle-product-meta__variants--single-variant' data-variant-id="${id}"></div>
      `;

      output = output.replace("##productVariants##",variant_html);
    }

    $outputContainer.append(output);

  }

  function retrieveID (input) {
    return (window.atob(input)).split("/").pop();
  }

  function getBundleProducts() {
    let bundle_items = [],
        item_titles = [];

    $container.find('.product-bundle-item').each(function() {
      let hasVariants = $(this).hasClass('product-bundle-item--has-variants'),
          variant_id = 0;

      let product_title = $(this).find('.bundle-product-meta__title').text().trim();
      if(hasVariants) {
        variant_id = $(this).find("select").find(":selected").data('variant-id');
        product_title = product_title + " - " + $(this).find("select").find(":selected").text();
      } else {
        variant_id = $(this).find("[data-variant-id]").data("variant-id");
      }

      bundle_items.push(variant_id);
      item_titles.push(product_title);
    });

    addBundleToCart(bundle_items, item_titles);
  }

  function addBundleToCart (bundle_items, item_titles) {
    let randomGeneratedID = Math.floor((Math.random() * 1000000) + 1),
        items_data = [],
        bundle_contents = [];

    for (let i=0;i<bundle_items.length;i++) {
      items_data.push({ quantity: 1, id: bundle_items[i], properties: {'_bundleItemType': 'child', '_bundleUniqueID': randomGeneratedID} });
    }

    for (let k=0;k<item_titles.length;k++) {
      bundle_contents.push(item_titles[k]);
    }

    items_data.push({quantity: 1, id: $container.data('parent-bundle-id'), properties: { '_bundleItemType': 'parent', '_bundleUniqueID': randomGeneratedID, '_bundleContents': bundle_contents }});

    $.post({
      url: '/cart/add.js',
      data: {
        items: items_data
      },
      success: function() {
        $('body').trigger('added.ajaxProduct');
        $container.removeClass('product-bundle--loading');
      },
      error: function(xhr, textStatus, errorThrown)
      {
        console.error('Add to cart error: ',textStatus,' / ',errorThrown);
        setTimeout(function(){
          $('#CartDrawer .drawer__scrollable').append('<p class="errors promotion-message">Unable to add bundle to cart</p>');
        },500);
        $('body').trigger('added.ajaxProduct');
        $container.removeClass('product-bundle--loading');
      }
    });
  }

  function updateCartButton() {
    let $cartButton = $container.find('.add-to-cart--bundle'),
        outOfStockBundle = false;

    $container.find('.product-bundle-item').each(function() {
      if($(this).hasClass('product-bundle-item--out-of-stock')) {
        outOfStockBundle = true;
      }
    })

    if (outOfStockBundle) {
      $cartButton.text('Out of Stock')
          .addClass('disabled')
          .prop('disabled', false);
    }
  }

  function removeItemsFromCart (keys) {
    let keys_to_remove = keys.split(','),
        qty = 0,
        items_data = { updates: {} };

    for(let i=0;i<keys_to_remove.length;i++) {
      items_data.updates[keys_to_remove[i]] = qty;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: items_data,
      dataType: 'json',
      success: function() {
        $('body').trigger('added.ajaxProduct');
        $('.drawer-contents').removeClass('drawer-contents--loading');
        theme.BundleDrawer.close();
      }
    });
  }

  function cartListeners() {
    let $body = $('body');

    $body.on('click', '.bundle-remove', function(e) {
      e.preventDefault();
      $('.drawer-contents').addClass('drawer-contents--loading');
      removeItemsFromCart($(this).data('remove-ids'));
    });

    $body.on('click', '.bundle-btn', function() {
      let bundle_id = $(this).data('bundle-id');
      $('#BundleDrawer .bundle-wrapper').removeClass('bundle-wrapper--shown');
      $('#BundleDrawer .bundle-wrapper--'+bundle_id).addClass('bundle-wrapper--shown');
      theme.BundleDrawer.open();
    });
  }

  function init (container) {
    $container = $(container);
    let $body = $('body');

    $body.on('productBundles:loaded', function() {
      $container.removeClass('product-bundle--loading');
      updateCartButton();
    });

    $('.add-to-cart--bundle').on('click',function(e) {
      e.preventDefault();
      $container.addClass('product-bundle--loading');
      getBundleProducts();
    });

    $container.find('.product-bundle-item').each(function() {
      let $this = $(this);
      let search_input = $(this).data('gql-query');
      let query_limit = 100;

      if (search_input.includes("title:")) {
        query_limit = 1;
      }

      let search_query = config.search_query.replace("{{{searchQuery}}}",search_input);
      search_query = search_query.replace("{{{searchQTY}}}",query_limit);
      theme.GraphQL.sendRequest(search_query,"productBundles",$this);
    });

    cartListeners();

  }

  return {
    init: init,
    buildOutput: buildOutput
  }
})();

theme.AlsoAvailableIn = (function() {
  let config = {
    request_query: '',
    current_product: '',
    product_name: '',
    image_url_structure: ''
  };

  let swatch_html = `
    <a class="product-swatch-button {{{swatchCurrent}}}" href="{{{productURL}}}" title="{{{productTitle}}}"
       style="background-image:url({{{swatchURL}}});">
    </a>
    `;

  function init(container) {
    let $container = this.$container = $(container);
    config.request_query = $container.data('request-query');
    config.current_product = $container.data('current-product');
    config.image_url_structure = $container.data('image-url-structure');
    config.product_name = $container.data('product-name');

    let request_query = `
          {
            products(first: 100, query: "`+config.request_query+`") {
              edges {
                node {
                  onlineStoreUrl
                  title
                  handle
                  limitedEdition: metafield(namespace: "custom", key: "limited_edition_colours") {	
                    value	
                  }
                }
              }
            }
          }
        `;

    try {
      theme.GraphQL.sendRequest(request_query, "also-available");
    }
    catch(err) {
      console.error("Errors in GraphQL: "+err);
    }

  }

  function buildOutput(response) {
    let output_html = '';
    let output_html_limited = '';
    let product_arr = response.data.products.edges;
    let limitedColours = [];

    if(product_arr.length === 0) {
      return;
    }

    this.$container.show();

    for (let i=0;i<product_arr.length;i++) {
      let product_title = product_arr[i].node.title.split("|");
      let product_colour = product_title[1].trim();
      if (product_title[0].trim().replace('"','') != config.product_name) continue;
      if (product_arr[i].node.onlineStoreUrl === null) continue;

      let swatch_url = config.image_url_structure.replace("---productTitle---",product_title[product_title.length-1].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
      let output = swatch_html.replace("{{{swatchURL}}}",swatch_url);
      output = output.replace("{{{productURL}}}",product_arr[i].node.onlineStoreUrl);
      output = output.replace("{{{productTitle}}}",product_arr[i].node.title);
      if(product_arr[i].node.handle === config.current_product) {
        output = output.replace("{{{swatchCurrent}}}","aa-swatch--current");
      } else {
        output = output.replace("{{{swatchCurrent}}}");
      }

      if(product_arr[i].node.limitedEdition != null){
        let productLimited = JSON.parse(product_arr[i].node.limitedEdition.value);
        
        limitedColours.push.apply(limitedColours, productLimited);
      }
      
      if(limitedColours.includes(product_colour)){
        output_html_limited += output;
      }else{
        output_html += output;
      }

      
      
    }

    this.$container.find('.aa-container.core-colours').append(output_html);
    
    if(output_html_limited != ""){
      this.$container.find('.aa-container.limited-edition').append(output_html_limited);
      document.getElementById("le-colours").style.display = "block";
      document.getElementById("core-colours-title").innerHTML = "Essential Colours:";
    }
  }

  return {
    init: init,
    buildOutput: buildOutput
  };

})();


theme.GridSwatches = (function() {
  let config = {
    request_query: '',
    current_product: '',
    product_name: '',
    image_url_structure: '',
  };

  let swatch_html = `
    <div class="product-swatch-button {{{needsBorder}}}"
       style="background-image:url({{{swatchURL}}});">
       <a href="{{{variantURL}}}" title="{{{variantTitle}}}"></a>
    </div>
    `;

  function init(container) {
    let $container = this.$container = $(container);
    config.request_query = $container.data('request-query');
    config.current_product = $container.data('current-product');
    config.image_url_structure = $container.data('image-url-structure');
    config.product_name = $container.data('product-name');

    if ($container.find('.product-swatch-button').length > 0) {
      return;
    }

    let request_query = `
          {
            products(first: 100, query: "`+config.request_query+`") {
              edges {
                node {
                  onlineStoreUrl
                  title
                  handle
                }
              }
            }
          }
        `;

    try {
      theme.GraphQL.sendRequest(request_query, "grid-swatches", $container);
    }
    catch(err) {
      console.error("Errors in GraphQL: "+err);
    }

  }

  function buildOutput(response, output_container) {
    let output_html = '';
    let product_arr = response.data.products.edges;
    let product_name = output_container.data('product-name');
    let displayed_colour = output_container.data('shown-colour') || "";
    let primary_colour = "";

    if(product_arr.length === 0) {
      return;
    }

    for (let i=0;i<product_arr.length;i++) {
      let product_title = product_arr[i].node.title.split("|");
      if (product_title[0].trim().replace('"','') != product_name) {
        continue;
      }

      let colour_title = product_title[product_title.length-1].trim();
      let colour_title_formatted = product_title[product_title.length-1].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      let swatch_url = config.image_url_structure.replace("---productTitle---",colour_title_formatted);
      let output = swatch_html.replace("{{{swatchURL}}}",swatch_url);
      output = output.replace("{{{variantURL}}}",product_arr[i].node.onlineStoreUrl);
      output = output.replace("{{{variantTitle}}}",product_arr[i].node.title);
      if (colour_title_formatted == "white" || colour_title_formatted == "two-tone") {
        output = output.replace("{{{needsBorder}}}","has-border");
      }
      if(colour_title === displayed_colour) {
        primary_colour += output;
      } else {
        output_html += output;
      }
    }

    output_container.find('.grid-product__swatches').append(primary_colour);
    output_container.find('.grid-product__swatches').append(output_html);
  }

  return {
    init: init,
    buildOutput: buildOutput
  };

})();

theme.CartSwatches = (function() {
  let config = {
    request_query: '',
    current_product: '',
    product_name: '',
    image_url_structure: '',
  };

  let swatch_html = `
    <div class="product-swatch-button upsell-swatch-button {{{needsBorder}}} {{{currentActive}}}"
       data-price="{{{itemPrice}}}"
       data-discount-price="{{{discountedPrice}}}"
       data-product-colour="{{{itemColour}}}"
       data-variants='{{{itemVariants}}}'
       data-image="{{{itemImage}}}"
       style="background-image:url({{{swatchURL}}});">
    </div>
    `;

  function init(container) {
    let $container = this.$container = $(container);
    config.request_query = $container.data('request-query');
    config.current_product = $container.data('current-product');
    config.image_url_structure = $container.data('image-url-structure');
    config.product_name = $container.data('product-name');

    if ($container.find('.product-swatch-button').length > 0) {
      return;
    }

    let request_query = `
          {
            products(first: 100, query: "`+config.request_query+`") {
              edges {
                node {
                  id
                  title
                  tags
                  handle
                  images(first: 1) {
                    edges {
                      node {
                        url(transform: {maxWidth: 100})
                      }
                    }
                  }
                  variants(first: 20) {
                    edges {
                      node {
                        title
                        id
                        quantityAvailable
                      }
                    }
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                    }
                  }
                }
              }
            }
          }
        `;

    try {
      theme.GraphQL.sendRequest(request_query, "cart-swatches", $container);
    }
    catch(err) {
      console.error("Errors in GraphQL: "+err);
    }

  }

  function buildOutput(response, output_container) {
    let output_html = '';
    let product_arr = response.data.products.edges;
    let product_name = output_container.data('product-name');
    let displayed_colour = output_container.data('shown-colour') || "";
    let primary_colour = "";

    if(product_arr.length === 0) {
      return;
    }

    for (let i=0;i<product_arr.length;i++) {
      let product_title = product_arr[i].node.title.split("|");
      if (product_title[0].trim().replace('"','') != product_name || product_arr[i].node.tags.includes("hide_from_upsell")) {
        continue;
      }

      let colour_title = product_title[product_title.length-1].trim();
      let colour_title_formatted = product_title[product_title.length-1].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      let swatch_url = config.image_url_structure.replace("---productTitle---",colour_title_formatted);
      let output = swatch_html.replace("{{{swatchURL}}}",swatch_url);
      let product_price = product_arr[i].node.priceRange.minVariantPrice.amount;
      if (colour_title_formatted == "white") {
        output = output.replace("{{{needsBorder}}}","has-border");
      }

      output = output.replace("{{{itemImage}}}",product_arr[i].node.images.edges[0].node.url);
      output = output.replace("{{{itemColour}}}",colour_title_formatted);

      // Check pricing (if discount is required)
      for(let t=0;t<product_arr[i].node.tags.length;t++) {
        let tag = product_arr[i].node.tags[t];
        if(tag.includes('upsell_discount:')) {
          let discount_percentage = parseFloat(tag.split(':')[1]);
          let discounted_price = (product_price - (product_price*discount_percentage)).toFixed(2);
          output = output.replace("{{{discountedPrice}}}",discounted_price);
          break;
        }
      }
      output = output.replace("{{{itemPrice}}}",product_price);

      // Build variant output
      let variant_output = "";
      let already_selected = false;
      for(let v=0;v<product_arr[i].node.variants.edges.length;v++) {
        let variant = product_arr[i].node.variants.edges[v].node,
            available = true,
            show_selection = false;
        if (variant.quantityAvailable<=0) {
          available = false;
        }
        if (!already_selected && available) {
          show_selection = true;
          already_selected = true;
        }
        let html = `
          <div class="upsell-item__variant-button ${show_selection ? 'variant-selected' : ''} ${!available ? 'variant-oos' : ''}" data-variant-id="${theme.Helpers2.retrieveID(variant.id)}">${variant.title}</div>
        `;
        variant_output+=html;
      }

      output = output.replace("{{{itemVariants}}}",variant_output);

      if(colour_title === displayed_colour) {
        primary_colour += output;
        primary_colour = primary_colour.replace("{{{currentActive}}}","selected")
      } else {
        output_html += output;
      }
    }

    output_container.find('.upsell-swatches').append(primary_colour);
    output_container.find('.upsell-swatches').append(output_html);

  }

  return {
    init: init,
    buildOutput: buildOutput
  };

})();


$(document).ready(function() {
  $('[data-section-type="also-available"]').each(function() {
    theme.AlsoAvailableIn.init(this);
  });

  $('[data-section-type="grid-swatches"]').each(function() {
    theme.GridSwatches.init(this);
  });

  $('[data-section-type="bundle"]').each(function() {
    theme.ProductBundles.init(this);
  });

  if ($('.product__waitlist-button-container').length>0 && $('.product__waitlist-button-container').data('waitlistvariants')) {

    if (typeof(KlaviyoSubscribe)==='undefined') {
        var s = document.createElement('script');
        s.type='text/javascript';
        s.setAttribute('src', '//www.klaviyo.com/media/js/public/klaviyo_subscribe.js');
        document.body.appendChild(s);
    }

    if ($('.btn.klaviyo-bis-trigger').length>0 && !$('.btn.klaviyo-bis-trigger').parent().hasClass('klaviyo-bis-trigger__container')) {
        $('.btn.klaviyo-bis-trigger').wrap('<div class="klaviyo-bis-trigger__container"></div>');
    }
    jQuery('.product-section').on('variantChange', function(event){
      if (event.variant && $('.product__waitlist-button-container').data('waitlistvariants')) {
        if ($('.btn.klaviyo-bis-trigger').length>0 && !$('.btn.klaviyo-bis-trigger').parent().hasClass('klaviyo-bis-trigger__container')) {
            $('.btn.klaviyo-bis-trigger').wrap('<div class="klaviyo-bis-trigger__container"></div>');
        }
        var waitListIDstr=''+$('.product__waitlist-button-container').data('waitlistvariants');
        var waitListIDs=(typeof(waitListIDstr)==='string' ? waitListIDstr.split(',') : []), vID=''+event.variant.id;
        if (typeof(waitListIDstr)==='object') { waitListIDs=waitListIDstr; }

        if (waitListIDs.indexOf(vID)>=0) {
            $('.page-content--product').addClass('product--no-bis');
            $('.product__waitlist-button-container').show();
        } else {
            $('.page-content--product').removeClass('product--no-bis');
            $('.product__waitlist-button-container').hide();
        }

        $('#WaitlistModal').data('variant', event.variant.id).attr('data-variant', event.variant.id);
      }
    });
  }



  $(document).on('click', '.quick-add-swatch', function() {
    let variant_id = $(this).data('variant-id');

    let upsellData = $(this).data('upsell-data');
    let properties = false;
    
    if (upsellData) {
      properties = {
        '_single_upsell': upsellData
      }
    }

    if(!$(this).hasClass('available--false')){
      theme.Helpers2.addItemToCartFromID(variant_id, properties);
    }
    
  })

  $(document).on('click', '.var-selector-trigger', function() {
    $(this).siblings(".var-selector").toggleClass("show");
  });


  // 2022 Cart Promotion listeners
  $(document).on('click', '.upsell-item__add-button', function() {
    let $this = $(this),
        variant_id,
        properties = {};
    if ($this.hasClass('upsell-item__add-button--variant')) {
      variant_id = $this.parent().prev().find('.variant-selected').data('variant-id');
    } else {
      variant_id = $this.data('variant-id');
    }
    if ($this.hasClass('upsell-item__add-button--discounted')) {
      properties["_upsell-discount"] = true;
    }
    if ($this.hasClass('upsell-item__add-button--tier')) {
      properties["_upsell-tier"] = $(this).data('item-tier');
    }
    theme.Helpers2.addItemToCartFromID(parseInt(variant_id), properties);
  });

  $(document).on('click', '.upsell-swatch-button', function() {
    let $this = $(this);
    if($this.hasClass('current')) {
      return;
    }
    let $upsell_container = $this.parents('.upsell_item'),
        $variant_container = $upsell_container.find('.upsell-item__variant-selector'),
        $price_container = $upsell_container.find('.upsell-item__price'),
        current_currency = $('.site-nav__currency-picker-item').find('span').text();

    $upsell_container.find('.product-swatch-button').each(function() {
      $(this).removeClass('selected');
    })

    $this.addClass('selected');

    $variant_container.empty().append($this.data('variants'));

    $upsell_container.find('.upsell-item__image img').attr('src',$this.data('image'));
    $upsell_container.find('.upsell-item__title--colour').text($this.data('product-colour'));

    $price_container.empty();
    if ($this.data('discount-price') != "{{{discountedPrice}}}") {
      $price_container.append(`<div class="upsell-item__price--discounted"><span class=money>$${$this.data('discount-price')} ${current_currency}</span></div>`);
    }
    $price_container.append(`<div class="upsell-item__price--original"><span class=money>$${$this.data('price')} ${current_currency}</span></div>`);

  });

  $(document).on('click', '.upsell-item__variant-button', function() {
    let $this = $(this);
    if($this.hasClass('variant-oos')) {
      return;
    }
    $this.parent().find('.upsell-item__variant-button').removeClass('variant-selected');
    $this.addClass('variant-selected');
  })
});

window.addEventListener('DOMContentLoaded', () => {
  $(document).on('click', '#cartRemoveGift', function(e) {
    e.preventDefault;

    let key = this.getAttribute('data-key');
    theme.Helpers2.removeSingleItemFromCart(key);
  })
})